const PlusIcon = () => {
    return ( 
        <div style={{border: 'none' , marginLeft: '20px' , marginRight: '5px' , padding: '0'}} className='plus-icon'>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 9.38144H10.6186V0H9.38144V9.38144H0V10.6186H9.38144V20H10.6186V10.6186H20V9.38144Z" fill="black"/>
            </svg>
        </div>
    );
}

export default PlusIcon;